<template>
  <div class="scene-wrapper">
    <HeadLoader v-if="loaderOpen" :isLoading="isLoading" @continue="loaderOpen = false"/>
    <div ref="sceneContainer" class="scene-container"></div>
  </div>
</template>

<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import {
  createRenderer,
  createCamera,
  addLights,
  loadModel,
  centerAndScaleModel,
  setModelColor,
} from "@/services/Model3DServices/threeService";
import HeadLoader from "./HeadLoader.vue";

export default {
  data() {
    return {
      rotationTween: null,
      targetRotation: 0,
      rotationSpeed: 0,
      isLoading: true,
      loaderOpen:true,
    };
  },
  components:{
    HeadLoader
  },

  props: {
    colorMode: {
      type: String,
      default: "gray", // Opciones: "gray", "blue", "green"
      validator: (value) => ["gray", "blue", "green"].includes(value),
    },
  },
  watch: {
    colorMode(newColor) {
      if (this.model) {
        this.rotationSpeed = 0.4;
        this.targetRotation = this.model.rotation.y + Math.PI * 2
        setModelColor(this.model, newColor);
      }
    },
  },
  mounted() {

    this.initScene();
    window.addEventListener("resize", this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    initScene() {
      const container = this.$refs.sceneContainer;
      this.renderer = createRenderer(container);
      this.scene = new THREE.Scene();
      this.camera = createCamera(container);
      addLights(this.scene);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      loadModel(
        "/models/modelo1.glb",
        (gltf) => {
          this.model = gltf.scene;
          this.scene.add(this.model);

          if (gltf.animations && gltf.animations.length > 0) {
            this.mixer = new THREE.AnimationMixer(this.model);
            gltf.animations.forEach((clip) => {
              this.mixer.clipAction(clip).play();
            });
          }

          centerAndScaleModel(this.model);
          setModelColor(this.model, this.colorMode);

          this.controls.target.copy(this.model.position);
          this.controls.update();

          this.isLoading = false; // <-- Oculta el loader al terminar
        },
        (error) => {
          console.error("Error al cargar el modelo:", error);
          this.isLoading = false; // Oculta el loader incluso si falla
        }
      );

      this.animate();
    },

    onWindowResize() {
      const container = this.$refs.sceneContainer;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      this.renderer.setPixelRatio(window.devicePixelRatio);
    },

    animate() {
      requestAnimationFrame(this.animate);

      if (this.model) {
        if (this.rotationSpeed > 0) {
          this.model.rotation.y += this.rotationSpeed;
          if (this.model.rotation.y >= this.targetRotation) {
            this.model.rotation.y = this.targetRotation % (Math.PI * 2);
            this.rotationSpeed = 0;
          }
        }

        if (this.colorMode === "green") {
          this.model.position.y = Math.sin(Date.now() * 0.002) * 0.1 + 1.5;
        }
      }

      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
  },
};
</script>


<style scoped>
.scene-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.scene-wrapper {
  width: 100%;
  height: 100%;
}

</style>
